<template>
<div class="wrapper">
  <div class="filterTitle">
    {{ value }}
  </div>
  <!--<i class="fa fa-chevron-down" v-if="!isUp"></i>
  <i class="fa fa-chevron-up" v-if="isUp"></i>-->
</div>
</template>

<script>
export default {
  name: "SimpleFilterHeader",
  props:["isUp","value"],
  emits:["toogleFilter"],
  methods:{
    toogleFilter(){
      this.$emit("toogleFilter");
    }
  }
}
</script>

<style scoped>
.wrapper:hover{
  cursor: pointer;
}

.filterTitle{
  font-family: "Montserrat Bold";
  padding-right: 13px;
  color: #b9b6b6;
  text-transform: uppercase;
  letter-spacing: 0.15px;
}

@media (max-width: 839px){

  .filterTitle {
    color: #080647;
    letter-spacing: 0px;
    font-size: 15px;
  }

  .filter_mobile i {
    color: #080647;
  }

  .filter_mobile {
    padding-bottom: 0;
  }
}

</style>